import { Component, OnInit, Input } from "@angular/core";
import { RouteInfo } from "../../entidades/entidades";

@Component({
  selector: "app-elementos-nav",
  templateUrl: "./elementos-nav.component.html",
  styleUrls: ["./elementos-nav.component.css"]
})
export class ElementosNavComponent implements OnInit {
  @Input("menuitem") menuitem: RouteInfo;
  @Input("depth") depth: number;
  constructor() {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }
  ngOnInit() {}
}
